'use client';

import { cn } from '@core/utils';

import { AD_PLACEMENTS } from './adPlacements';
import { NativeAdSlot } from './NativeAdSlot';

interface PolicyGuideSideAdBannerProps {
  className?: string;
  footer?: React.ReactNode;
}

//* 광고가 hidden이어도 aside는 렌더해 footer를 표시한다 (사이드바가 다른 콘텐츠도 담음).
export const PolicyGuideSideAdBanner = ({
  className,
  footer,
}: PolicyGuideSideAdBannerProps) => (
  <aside
    className={cn('hidden w-300 shrink-0 flex-col gap-16 xl:flex', className)}
  >
    <NativeAdSlot {...AD_PLACEMENTS.policyGuideSide} />
    {footer}
  </aside>
);
